export const AllProducts = [
    {
        name: 'Atlas 9000',
        route: './zeiss/atlas-9000'
    },
    {
        name: 'Cirrus OCT 4000',
        route: './zeiss/cirrus-oct-4000'
    },
    {
        name: 'Cirrus OCT 5000',
        route: './zeiss/cirrus-oct-5000'
    },
    {
        name: 'Cirrus OCT 500',
        route: './zeiss/cirrus-oct-500'
    },
    {
        name: 'Matrix 715',
        route: './zeiss/matrix-715'
    },
    {
        name: 'Cirrus OCT 400',
        route: './zeiss/cirrus-oct-400'
    },
    {
        name: 'HFA 740i',
        route: './zeiss/hfa-740i'
    },
    {
        name: "Virtual Eye VRVF",
        route: "./virtual-vision/virtual-eye-vrvf"
    },
    {
        name: 'Retinomax K+ Screen',
        route: './s4optik/retinomax-k-screen'
    },
    {
    name: 'VrXII',
    route: './reichert/vrxii'
  },
  {
    name: 'SightCheck',
    route: './reichert/sightcheck'
    },
  {
    name: 'TRS-5100',
    route: './marco/trs-5100'
    },
  {
    name: "iCare® TAO1i Tonometer",
    route: "./icare/icare®-tao1i-tonometer"
  },
  {
    name: "iCare® IC-100 Tonometer",
    route: "./icare/icare®-ic-100-tonometer"
  },
  {
    name: "iCare® IC-200 Tonometer",
    route: "./icare/icare®-ic-100-tonometer"
    },
  {
    name: 'HDR-9000 Digital Refractor',
    route: './huvitz/hdr-9000-digital-refractor'
  },
  {
    name: 'HLM-9000 Auto Lensmeter',
    route: './huvitz/hlm-9000-auto-lensmeter'
  },
  {
    name: 'HRK-9000a Ref Keratometer',
    route: './huvitz/hrk-9000a-ref-keratometer'
    },
  {
    name: 'BQ 900 Slit Lamp',
    route: './haag-streit/bq-900-slit-lamp'
  },
  {
    name: 'BP 900 Slit Lamp',
    route: './haag-streit/bp900-slit-lamp'
  },
  {
    name: 'BM900 Slit Lamp',
    route: './haag-streit/bm900-slit-lamp'
  },
  {
    name: 'BI900 Slit Lamp',
    route: './haag-streit/bi900-slit-lamp'
  },
  {
    name: '7900 Instrument Stand',
    route: './haag-streit/7900-instrument-stand'
  },
  {
    name: 'FX-920 Exam Chair',
    route: './haag-streit/fx-920-exam-chair'
  },
  {
    name: '6200 Exam Chair',
    route: './haag-streit/6200-exam-chair'
  },
  {
    name: '7000 Procedure Chair',
    route: './haag-streit/7000-procedure-chair'
    },
  {
    name: 'S390L Firefly Digital Slit Lamp Imaging System',
    route: './eyefficient/s390l-firefly-digital-slit-lamp-imaging-system'
  },
  {
    name: "iCare® EIDON",
    route: "./icare/icare®-eidon"
  },
  {
    name: "iCare® Compass",
    route: "./icare/icare®-compass"
  },
  {
    name: "name: 'S360 Slit Lamp",
    route: "./eyefficient/s360-slit-lamp"
  },
  {
    name: "2000 CH Examination Chair",
    route: "./s4optik/2000-ch-examination-chair"
  },
  {
    name: "2500 CH Examination Chair",
    route: "./s4optik/2500-ch-examination-chair"
  }, {
    name: "2000-ST Instrument Stand",
    route: "./s4optik/2000-st-instrument-stand"
  },
  {
    name: "2000 Combo Chair and Stand",
    route: "./s4optik/2000-combo-chair-and-stand"
  },
  {
    name: "SL-Z3 Slit Lamp",
    route: "./s4optik/sl-z3-slit-lamp"
  },
  {
    name: 'SL-H5 Slit Lamp',
    route: "./s4optik/sl-h5-slit-lamp"
  },
  {
    name: "Tearcheck®",
    route: "./E-Swin/tearcheck®"
  },
  {
    name: "E-Eye",
    route: "./E-Swin/e-eye"
  },

];
export default AllProducts

